<template>
  <div>
    <el-dialog :visible.sync="showDialog"
               :title="$t('upload.Upload')"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               custom-class="window"
               width="40%"
               top="10vh"
               :show-close="false">
      <div class="uploadDiv">
        <div class="folderDiv">
          <el-select size="small"
                     :placeholder="$t('documents.Folder')"
                     v-model="folderId">
            <el-option v-for="i in folderList"
                       :key="i.FolderId"
                       :label="i.Name"
                       :value="i.FolderId">
              <i v-if="i.FolderId"
                 class="el-icon-folder"
                 style="color:#ff9800;margin-right:5px;"></i> {{ i.Name }}
            </el-option>
          </el-select>
        </div>
        <el-upload class="upload"
                   ref="upload"
                   action=""
                   :multiple="true"
                   :auto-upload="false"
                   :show-file-list="false"
                   :on-change="handleFileChange"
                   :http-request="postUpFile">
          <el-button slot="trigger"
                     size="small"
                     type="primary">{{$t('upload.SelectDoc')}}</el-button>
          <el-button style="margin-left: 10px;"
                     size="small"
                     type="success"
                     :loading="btnLoading"
                     @click="postUpFile">{{$t('upload.Upload')}}</el-button>
        </el-upload>
        <el-table :data="fileList"
                  :show-header="false">
          <el-table-column width="55">
            <i class="el-icon-document"></i>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              {{scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-button size="mini"
                         circle
                         @click="removeFile(scope.$index)"
                         type="danger">
                <i class="el-icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="closeDialog(false)"
                   size="small">{{$t('upload.Cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { uploadDoc, getFolders } from '@/api/config'

export default {
  props: {
    folderId: {
      type: String,
      default: null
    },
    orderBy: {
      type: String,
      default: null
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fileList: [],
      btnLoading: false,
      folderCondition: {
        JobsiteId: null,
        PageIndex: 1,
        PageSize: 30
      },
      folderList: []
    }
  },
  computed: {
    ...mapState(['jobsiteID'])
  },
  created () {

  },
  mounted () {

  },
  watch: {
    showDialog (to, from) {
      if (to) {
        this.fileList = []
        this.getFolders()
      }
    }
  },
  methods: {
    handleFileChange (file, fileList) {
      this.fileList.push(file)
    },
    uploading (file) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        console.log(this.folderId)
        formData.append('file', file.raw)
        formData.append('JobsiteId', this.jobsiteID)
        formData.append('AllowSaveActivity', true)
        if (this.folderId) {
          formData.append('FolderId', this.folderId)
        }

        uploadDoc(formData).then(result => {
          resolve(1)
        }).catch(err => {
          console.log(err)
          this.btnLoading = false
        })
      })
    },
    async postUpFile () {
      this.btnLoading = true
      let time = 0
      for (let i of this.fileList) {
        if (i.size > 50000000) {
          this.$notify.closeAll()
          this.$notify({
            title: this.$t('api.WARNING'),
            message: this.$t('api.Fileslargerthan50Mcannotbeuploaded'),
            showClose: false
          })
          this.btnLoading = false
          return
        }
        time += await this.uploading(i)
      }
      if (time === this.fileList.length) {
        this.closeDialog(true)
      }
      this.btnLoading = false
    },
    removeFile (index) {
      this.fileList.splice(index, 1)
    },
    closeDialog (needRefresh) {
      this.fileList = []
      this.$emit('closeDialog', needRefresh)
    },
    getFolders () {
      this.folderCondition.JobsiteId = this.jobsiteID
      this.folderCondition.OrderBy = this.orderBy
      getFolders(this.folderCondition).then(res => {
        this.folderList = res.Data
        this.folderList.unshift({ 'FolderId': null, 'JobsiteId': this.jobsiteID, 'Name': this.$t('documents.NoFolder'), 'IsDeleted': false })
      })
    }
  },
  components: {

  }
}
</script>

<style  lang="scss">
.uploadDiv {
  min-height: 250px;
}
.folderDiv {
  float: left;
  margin-bottom: 10px;
}
.upload {
  float: right;
  margin-bottom: 10px;
}
</style>
